import axiosApiInstance from '../axios/axiosApiInstance';
import { StoreResponseDto } from '../types/store-response-dto';

export const fetch = async (): Promise<StoreResponseDto> => {
  const response = await axiosApiInstance.get('/stores');

  return response?.data;
};
